import { CloseButton } from '@common/ui/CloseButton';
import { Box, Modal, Stack, styled } from '@mui/material';
import { PropsWithChildren, ReactNode } from 'react';

const ModalContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  margin: theme.spacing(8, 'auto'),
  backgroundColor: theme.palette.background.default,
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,

  '&.with-bottom-padding': {
    paddingBottom: theme.spacing(6),
  },
}));

interface AppModalProps {
  open: boolean;
  onClose: () => void;
  title?: ReactNode;
  width?: number;
  closeButton?: boolean;
  bottomPadded?: boolean;
}

export default function AppModal({
  children,
  open,
  onClose,
  title,
  width = 540,
  closeButton,
  bottomPadded,
}: PropsWithChildren<AppModalProps>) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        overflow: 'auto',
      }}
    >
      <ModalContainer sx={{ maxWidth: width }} className={bottomPadded ? 'with-bottom-padding' : ''}>
        <Stack direction="column" justifyContent="center" alignItems="stretch" spacing={2}>
          <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={2}>
            <div>{title}</div>
            {closeButton && <CloseButton onClick={onClose} />}
          </Stack>
          <div>{children}</div>
        </Stack>
      </ModalContainer>
    </Modal>
  );
}
